import {px} from '../Theme/spacing';
import {recipes as baseRecipes, defineRule, self} from '../Utilities/jss';
import {font} from './fonts';
import {theme as t} from './theme';

const recipes = {
    ...baseRecipes,
    ring2(color: string) {
        return recipes.ring('2px', '2px', color);
    },
};

export const RsnButton = defineRule('.RsnButton', {
    ...font['heading-s'],
    cursor: 'pointer',
    width: '100%',
    minWidth: 0,
    borderRadius: t.borderRadius.lg,
    paddingInline: t.spacing['4'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: t.spacing['1'],
    transitionProperty: 'color, background-color, border-color, text-decoration-color, fill, stroke',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDuration: '300ms',
    ...self.active({
        transitionDuration: '100ms',
    }),
    height: px(52),
    ...self.disabled({
        cursor: 'default',
        backgroundColor: t.colors.neutral['30'],
        border: `1px solid ${t.colors.neutral['40']}`,
        color: t.colors.neutral['60'],
        ...self.active({
            backgroundColor: t.colors.neutral['30'],
            color: t.colors.neutral['60'],
        }),
    }),
    ...self.modifier('Primary', {
        backgroundColor: t.colors.primary['30'],
        color: t.colors.neutral['10'],

        ...self.focusVisible({
            ...recipes.ring2(t.colors.primary['20']),
        }),
        ...self.active({
            backgroundColor: t.colors.primary['40'],
        }),
    }),
    ...self.modifier('Gold', {
        backgroundColor: t.colors.gold['30'],
        color: t.colors.neutral['100'],

        ...self.focusVisible({
            ...recipes.ring2(t.colors.gold['20']),
        }),
        ...self.active({
            backgroundColor: t.colors.gold['40'],
        }),
    }),
    ...self.modifier('Secondary', {
        backgroundColor: t.colors.primary['10'],
        color: t.colors.primary['30'],

        ...self.focusVisible({
            ...recipes.ring2(t.colors.primary['20']),
        }),
        ...self.active({
            backgroundColor: t.colors.primary['20'],
            color: t.colors.primary['40'],
        }),
    }),
    ...self.modifier('Tertiary', {
        backgroundColor: t.colors.neutral['10'],
        color: t.colors.primary['30'],

        ...self.focusVisible({
            ...recipes.ring2(t.colors.primary['20']),
        }),
        ...self.active({
            backgroundColor: t.colors.shade['20'],
            color: t.colors.primary['40'],
        }),
    }),
    ...self.modifier('Cautionary', {
        backgroundColor: t.colors.danger['10'],
        color: t.colors.danger['30'],

        ...self.focusVisible({
            ...recipes.ring2(t.colors.danger['20']),
        }),
        ...self.active({
            backgroundColor: t.colors.danger['20'],
            color: t.colors.danger['40'],
        }),
    }),
    ...self.modifier('Small', {
        ...font['text-l-bold'],
        height: t.spacing['11'],
    }),
});
